/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React from 'react'

export const PieTimer = ({height, width, start, current, end}) => {
 
    let duration = end-start
    let progress = current-start
    var angle = 360 * (progress/duration)
    angle %= 360

    let rad = (angle * Math.PI / 180)
    let x = Math.sin(rad) * (width / 2)
    let y = Math.cos(rad) * - (height / 2)
    let mid = (angle > 180) ? 1 : 0
    let sweepDirection = 1

            
    var shape = 'M 0 0 v '+ -(height / 2) + ' A ' + (width / 2) + ' ' + (width / 2) + ' 1 '
                + mid + ' ' + sweepDirection + ' ' 
                + x  + ' ' 
                +  y  + ' z'
    

    return (
        <div className="PieTimer">
            <svg width={width} height={width} viewBox={'0 0 ' + width + ' ' + height}>
                <path 
                    className="svg-border"
                    transform={'translate(' + width/2 + ' ' + height/2 + ')'}
                    d={shape}
                    fill="var(--grey3-color)"
                />
                <path
                    className="svg-loader"
                    transform={'translate(' + width/2 + ' ' + height/2 + ')  scale(.84)'}
                    d={shape}
                    fill="var(--grey4-color)"
                />
                <circle
                    cx={width/2}
                    cy={width/2}
                    r={width/2}
                    fill="rgba(255,255,255,0.2)"
                />
            </svg>
        </div>
    )
}
